export default __webpack_public_path__ + "static/blue_pin-81bfe8ab262d97b0a7b1b7b22026adb8.png";